import React, { useRef } from "react";
import "./imageModal.css";

const ImageModal = ({
  imageSrc,
  zoomLevel,
  handleZoomIn,
  handleZoomOut,
  handleCloseImageModal,
  setZoomLevel,
}) => {
  const containerRef = useRef(null);
  const isDragging = useRef(false);
  const startPosition = useRef({ x: 0, y: 0 });
  const scrollPosition = useRef({ left: 0, top: 0 });

  const handleWheelZoom = (e) => {
    e.preventDefault();
    const delta = Math.sign(e.deltaY);
    const zoomStep = 0.02;
    setZoomLevel((prev) => {
      const newZoom = delta > 0 ? prev - zoomStep : prev + zoomStep;
      return Math.min(Math.max(newZoom, 0.5), 5);
    });
  };

  const handleMouseDown = (e) => {
    isDragging.current = true;
    startPosition.current = { x: e.clientX, y: e.clientY };
    if (containerRef.current) {
      scrollPosition.current = {
        left: containerRef.current.scrollLeft,
        top: containerRef.current.scrollTop,
      };
    }
  };

  const handleMouseMove = (e) => {
    if (!isDragging.current || !containerRef.current) return;
    const dx = e.clientX - startPosition.current.x;
    const dy = e.clientY - startPosition.current.y;
    containerRef.current.scrollLeft = scrollPosition.current.left - dx;
    containerRef.current.scrollTop = scrollPosition.current.top - dy;
  };

  const handleMouseUp = () => {
    isDragging.current = false;
  };

  return (
    <div className="image-modal" onWheel={handleWheelZoom}>
      <div className="modal-content">
        <div className="modal-header">
          <span className="close" onClick={handleCloseImageModal}>
            &times;
          </span>
          <div className="zoom-controls">
            <button onClick={handleZoomOut}>-</button>
            <span>{zoomLevel.toFixed(1)}x</span>
            <button onClick={handleZoomIn}>+</button>
          </div>
        </div>
        <div
          className="image-container"
          ref={containerRef}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
        >
          <img
            src={imageSrc}
            alt="Zoomable"
            style={{
              transform: `scale(${zoomLevel})`,
              transition: "transform 0.25s ease",
              userSelect: "none",
              pointerEvents: "none", // So the image doesn’t block drag
            }}
            draggable={false}
          />
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
